import { useTheme, css } from '@emotion/react'
import { BsArrowUpShort, BsArrowDownShort } from 'react-icons/bs'

export function MediaQuery(screen, measure) {
    const theme = useTheme()
    const bpSwitch = (screenType) => {
        switch (screenType) {
            case 'sm':
                return theme.screens?.sm
            case 'md':
                return theme.screens?.md
            case 'lg':
                return theme.screens?.lg
            case 'xl':
                return theme.screens?.xl
            case 'xxl':
                return theme.screens?.xxl
        }
    }
    return `@media (${measure}-width: ${bpSwitch(screen)})`
}

export function ProfitOrLossCheck({ percentage, background }) {
    percentage = `${percentage}`
    return (
        <span
            css={(theme) => css`
                ${background
                    ? `background-color: ${
                          percentage.charAt(0) == '-'
                              ? theme.colors?.danger
                              : theme.colors?.success
                      };
                    color: ${theme.colors?.white};
                    border-radius: ${theme.borderRadius?.full};
                    justify-content: center;
                    align-items: center;
                    display: flex;
                    ${'' /* padding: 0.65rem 0.5rem; */}
                    height: 3.5rem;
                    width: 3.5rem;
                    flex-direction: column;

                    `
                    : `color: ${
                          percentage.charAt(0) == '-'
                              ? theme.colors?.danger
                              : theme.colors?.success
                      };`}
            `}
        >
            {percentage.charAt(0) == '-' ? (
                <>
                    <BsArrowDownShort className="inline-block" />
                    {percentage.replace('-', '')}
                </>
            ) : (
                <>
                    <BsArrowUpShort className="inline-block" />
                    {percentage}
                </>
            )}
            %
        </span>
    )
}

export function currencyFormat(num, type, count) {
    return Intl.NumberFormat(count, {
        style: 'currency',
        currency: type
    }).format(num)
}

export function colorBack(colorName) {
    if (colorName?.charAt(0) === '#' || colorName === 'transparent') {
        return colorName
    }
    return false
}
